<template>
    <div class="field">
        <p class="control">
            <a class="button is-danger" @click="onLogOut">
                Logout
            </a>
        </p>
    </div>
</template>

<script>
    export default {
        name: "LogoutButton",
        methods: {
            async onLogOut() {
                await this.$store.dispatch('logout');
                alert('Log out successful');
                this.$router.replace('login');
            }
        }
    }
</script>

<style scoped>

</style>
